/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputMissionDrop
 */
export interface InputMissionDrop {
    /**
     * 
     * @type {string}
     * @memberof InputMissionDrop
     */
    customTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof InputMissionDrop
     */
    customTargetType?: string;
    /**
     * 
     * @type {number}
     * @memberof InputMissionDrop
     */
    stockAmmoId?: number;
    /**
     * 
     * @type {number}
     * @memberof InputMissionDrop
     */
    targetId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputMissionDrop
     */
    targetStatus: InputMissionDropTargetStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof InputMissionDrop
     */
    targetTypeId?: number;
}


/**
 * @export
 */
export const InputMissionDropTargetStatusEnum = {
    Injured: 'injured',
    Destroyed: 'destroyed',
    NotInjured: 'not_injured',
    NoDetonation: 'no_detonation',
    MineLaying: 'mine_laying',
    DetonationAttempt: 'detonation_attempt',
    DropFailed: 'drop_failed',
    Humanitarian: 'humanitarian',
    None: 'none'
} as const;
export type InputMissionDropTargetStatusEnum = typeof InputMissionDropTargetStatusEnum[keyof typeof InputMissionDropTargetStatusEnum];


/**
 * Check if a given object implements the InputMissionDrop interface.
 */
export function instanceOfInputMissionDrop(value: object): boolean {
    if (!('targetStatus' in value)) return false;
    return true;
}

export function InputMissionDropFromJSON(json: any): InputMissionDrop {
    return InputMissionDropFromJSONTyped(json, false);
}

export function InputMissionDropFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputMissionDrop {
    if (json == null) {
        return json;
    }
    return {
        
        'customTarget': json['customTarget'] == null ? undefined : json['customTarget'],
        'customTargetType': json['customTargetType'] == null ? undefined : json['customTargetType'],
        'stockAmmoId': json['stockAmmoId'] == null ? undefined : json['stockAmmoId'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'targetStatus': json['targetStatus'],
        'targetTypeId': json['targetTypeId'] == null ? undefined : json['targetTypeId'],
    };
}

export function InputMissionDropToJSON(value?: InputMissionDrop | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customTarget': value['customTarget'],
        'customTargetType': value['customTargetType'],
        'stockAmmoId': value['stockAmmoId'],
        'targetId': value['targetId'],
        'targetStatus': value['targetStatus'],
        'targetTypeId': value['targetTypeId'],
    };
}

